import { rbacCapabilityCheckAllOf } from '@libs/rbac/functions'
import { readHealthCheck } from '@libs/rbac/permissions'

export const canAccessToHealthCheck = rbacCapabilityCheckAllOf(
  readHealthCheck()
)

export const canAccessToHealthCheckDomainStatus = rbacCapabilityCheckAllOf(
  canAccessToHealthCheck
)

export const canAccessToHealthCheckPlatformStatus = rbacCapabilityCheckAllOf(
  canAccessToHealthCheck
)
